import React from 'react';

const VIEWBOX_WIDTH = 400;
const VIEWBOX_HEIGHT = 300;
const BORDER = 10;
const DIVIDER_Y = 150;

function AdrCodePreview({ code, description,  width = 150, showLabel = true, inlineInfo = false }) {
    const parts = (code || '').trim().split(/\s+/);
    const riskNumber = parts[0] || '--';
    const onuNumber  = parts[1] || '----';

    const topCenterY    = (BORDER + DIVIDER_Y) / 2;
    const bottomCenterY = (DIVIDER_Y + (VIEWBOX_HEIGHT - BORDER)) / 2;

    return (
        <div class="flex flex-col gap-2 ">
            {showLabel && <span className="text-sm ml-3 font-medium text-gray-500">Painel de segurança</span>}
            <div className="flex flex-col items-center gap-1">
                <div className="flex items-center gap-3">
                    <svg className="rounded-md"
                        viewBox={`0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`}
                        width={width}
                        xmlns="http://www.w3.org/2000/svg"
                        aria-label={`Painel ADR: ${riskNumber} / ${onuNumber}`}
                    >
                        <rect
                            x={BORDER / 2}
                            y={BORDER / 2}
                            width={VIEWBOX_WIDTH - BORDER}
                            height={VIEWBOX_HEIGHT - BORDER}
                            rx="30"
                            ry="30"
                            fill="#FF6600"
                            stroke="black"
                            strokeWidth={BORDER}
                        />
                        <line
                            x1={BORDER / 2}
                            y1={DIVIDER_Y}
                            x2={VIEWBOX_WIDTH - BORDER / 2}
                            y2={DIVIDER_Y}
                            stroke="black"
                            strokeWidth="8"
                        />
                        <text
                            x="50%"
                            y={topCenterY}
                            fontFamily="Arial, sans-serif"
                            fontSize="95"
                            fontWeight="bold"
                            textAnchor="middle"
                            dominantBaseline="middle"
                            fill="black"
                        >
                            {riskNumber}
                        </text>
                        <text
                            x="50%"
                            y={bottomCenterY}
                            fontFamily="Arial, sans-serif"
                            fontSize="95"
                            fontWeight="bold"
                            textAnchor="middle"
                            dominantBaseline="middle"
                            fill="black"
                        >
                            {onuNumber}
                        </text>
                    </svg>
                    {description && !inlineInfo && (
                        <div className="flex flex-col justify-center gap-2 border-l border-gray-200 pl-3" style={{ height: width * 0.75 }}>
                            <p className="text-sm font-semibold text-gray-800 leading-tight">{description}</p>
                            <div className="flex flex-col gap-1 mt-1">
                                <span className="text-xs text-gray-400 uppercase tracking-wide">Nº Risco</span>
                                <span className="text-base font-bold text-gray-700 font-mono">{riskNumber}</span>
                            </div>
                            <div className="flex flex-col gap-1">
                                <span className="text-xs text-gray-400 uppercase tracking-wide">Nº ONU</span>
                                <span className="text-base font-bold text-gray-700 font-mono">{onuNumber}</span>
                            </div>
                        </div>
                    )}
                    {inlineInfo && (
                        <div className="flex items-center gap-4 border-l border-gray-200 pl-3" style={{ height: width * 0.75 }}>
                            <div className="flex flex-col gap-0.5">
                                <span className="text-xs text-gray-400 uppercase tracking-wide">Nº Risco</span>
                                <span className="text-base font-bold text-gray-700 font-mono">{riskNumber}</span>
                            </div>
                            <div className="flex flex-col gap-0.5">
                                <span className="text-xs text-gray-400 uppercase tracking-wide">Nº ONU</span>
                                <span className="text-base font-bold text-gray-700 font-mono">{onuNumber}</span>
                            </div>
                            {description && (
                                <div className="flex flex-col gap-0.5">
                                    <span className="text-xs text-gray-400 uppercase tracking-wide">Descrição</span>
                                    <p className="text-sm font-semibold text-gray-800 leading-tight">{description}</p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

        </div>
    );
}

export default AdrCodePreview;
